'use es6';

import Env from 'enviro';

var isFunction = function isFunction(options) {
  return typeof options === 'function';
}; // IE11 symbols are just normal properties and don't need this to get picked up


var getOwnPropertySymbols = Object.getOwnPropertySymbols || function () {
  return [];
};

export default (function (options) {
  if (Env.deployed('hub-http') || !Object.freeze) return options;
  Object.freeze(options);
  Object.getOwnPropertyNames(options).concat(getOwnPropertySymbols(options)).forEach(function (name) {
    if (isFunction(options) && name !== 'caller' && name !== 'callee' && options[name] != null && !Object.isFrozen(options[name])) {
      Object.freeze(options[name]);
    }
  });
  return options;
});